<template>
  <div class="modal_card reverse categories-modal">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Управление категориями</h1>
      <form @submit.prevent="submitCategory">
        <b-field class="input_search grey" type="is-info">
          <b-input v-model="modalInfo.searchName" placeholder="Поиск категории"></b-input>
        </b-field>

        <CategoriesList
          @restore-category="restoreCategory"
          @delete-category="deleteCategory"
          :categories-list="categoriesList"
        />

        <div class="buttons_block">
          <b-field
            class="add_category grey"
            type="is-info"
            :message="errors.first('name')"
            :class="errors.first('name') ? 'error' : ''"
          >
            <b-input
              v-model="modalInfo.name"
              placeholder="Название категории"
              name="name"
              v-validate="{ required: true, min: 2, max: 20 }"
            ></b-input>
          </b-field>
          <button
            class="add_course_button modal_button left_button"
            type="submit"
            :disabled="modalInfo.name.length <= 0"
          >
            Добавить
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CategoriesList from '@/components/right_block/CategoriesList'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    CategoriesList
  },
  data() {
    return {
      modalInfo: {
        name: '',
        searchName: '',
        trashed: false
      },
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое значение',
            max: 'Слишком длинное значение'
          }
        }
      }
    }
  },
  computed: {
    categoriesList() {
      let data = this.$store.state.categories.ModalCategoriesList
      return data.filter(this.searchCategories)
    }
  },
  methods: {
    searchCategories(el) {
      return el.name.toUpperCase().includes(this.modalInfo.searchName.toUpperCase())
    },
    loadData() {
      this.$axios2
        .get('categories')
        .then((resp) => {
          this.$store.commit('setCategoriesList', { list: resp.data })
          this.$axios2
            .get('courses/list?category_id=' + resp.data[0].id)
            .then((response) => {
              this.$store.commit('setCategoryCoursesList', {
                list: response.data,
                index: 0
              })
            })
            .catch(this.$errorToast)
        })
        .catch(this.$errorToast)
      this.$axios2
        .get('categories?all=true')
        .then((resp) => {
          this.$store.commit('setModalCategoriesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    submitCategory() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }

        this.$axios2
          .post('categories', { name: this.modalInfo.name })
          .then(() => {
            this.$buefy.toast.open(toastInfo())
            this.modalInfo.name = ''
            this.$validator.reset()
            this.loadData()
          })
          .catch(this.$errorToast)
      })
    },
    restoreCategory(categoryID) {
      this.$axios2
        .patch('categories/' + categoryID)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    deleteCategory(categoryID) {
      this.$axios2
        .delete('categories/' + categoryID)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    }
  },
  mounted() {
    this.loadData()
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
